import { HTTP_CLASS_NAMES } from '@/constant/dynamic';
import { Predicate } from '@/types/common';
import { equals, isOneOf, pipe, prop, T } from '@/utils/common';

import { InjectorFactory, TagNode } from '../types';

const isValidHttpClassName = isOneOf(HTTP_CLASS_NAMES);

export const makeInjector: InjectorFactory =
  (render, predicate = T) =>
  (node, children) => {
    if (node.type !== 'tag') return null;
    if (!predicate(node)) return null;
    return render(node, children);
  };

export const getNodeClass = (node: TagNode) => node.attribs.class;
export const nodeNameIs = (nodeName: string): Predicate<TagNode[]> => pipe(prop('name'), equals(nodeName));
export const nodeClassIs = (nodeClass: string): Predicate<TagNode[]> => pipe(getNodeClass, equals(nodeClass));
export const nodeClassIncludes =
  (nodeClass: string): Predicate<TagNode[]> =>
  node =>
    getNodeClass(node)?.includes(nodeClass);
export const isHttpNodeClass = pipe(getNodeClass, isValidHttpClassName);
